const MAX_FILE = 10 * 1024 * 1024; // 10MB cho tệp không phải ảnh
const IMG_MAX_DIM = 1600;

function readAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

// Ảnh lớn -> thu nhỏ về tối đa 1600px (JPEG). Ảnh nhỏ giữ nguyên.
function downscaleImage(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onerror = reject;
    r.onload = () => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        const scale = Math.min(1, IMG_MAX_DIM / Math.max(img.width, img.height));
        if (scale >= 1) return resolve(r.result); // đã đủ nhỏ
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', 0.85));
      };
      img.src = r.result;
    };
    r.readAsDataURL(file);
  });
}

const dataUrlBytes = (d) => Math.round((d.length * 3) / 4);

// Chuyển 1 File thành đối tượng đính kèm để gửi.
export async function fileToAttachment(file) {
  if (file.type.startsWith('image/')) {
    const data = await downscaleImage(file);
    return { name: file.name || 'image.jpg', type: data.startsWith('data:image/jpeg') ? 'image/jpeg' : file.type, size: dataUrlBytes(data), data };
  }
  if (file.size > MAX_FILE) throw new Error(`Tệp "${file.name}" quá lớn (>10MB)`);
  const data = await readAsDataURL(file);
  return { name: file.name, type: file.type || 'application/octet-stream', size: file.size, data };
}

export const fmtSize = (n) => (n >= 1048576 ? (n / 1048576).toFixed(1) + 'MB' : Math.max(1, Math.round(n / 1024)) + 'KB');
